import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  IPreSuspendedModel,
  MY_ACCOUNT_CONFIG,
  PreSuspendedService,
} from '../../../../public-api';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { LoadingService, PopUpService } from 'lib-shared';

@Component({
  selector: 'lib-pre-suspended-page',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './pre-suspended-page.component.html',
  styleUrl: './pre-suspended-page.component.scss',
})
export class PreSuspendedPageComponent {
  preSuspendedService = inject(PreSuspendedService);
  translateService = inject(TranslocoService);
  loadingService = inject(LoadingService);
  popUpService = inject(PopUpService);
  private config = inject(MY_ACCOUNT_CONFIG);

  primaryColor: string = this.config.theme.primaryColor;

  whatsappNumbers: any = {
    en: this.config.whatsappNumbers.en,
    es: this.config.whatsappNumbers.es,
    he: this.config.whatsappNumbers.he,
    pt: this.config.whatsappNumbers.pt,
  };

  currentLang: string = '';

  preSuspendedData: IPreSuspendedModel;

  constructor(private router: Router) {
    this.loadingService.setLoading(true);
  }

  ngOnInit(): void {
    this.getPreSuspendedData();
    // Subscribe to language changes
    this.translateService.langChanges$.subscribe((lang: string) => {
      this.currentLang = lang; // Update currentLang when language changes
    });

    // Initialize currentLang with the current active language
    this.currentLang = this.translateService.getActiveLang();
  }

  reactivateAccount() {
    this.router.navigate(['/reactivate-account'], {
      queryParams: {
        transactionId: this.preSuspendedData.transactionID,
        amount: this.preSuspendedData.transactionAmount,
      },
    });
  }

  async getPreSuspendedData() {
    try {
      const res =
        await this.preSuspendedService.getPreSuspendedData<IPreSuspendedModel>();

      if (res.isSuccessful && res.result) {
        this.preSuspendedData = res.result;
      } else {
        this.popUpService.openPopUp('server-error');
      }
    } catch (error) {
      console.error('Error fetching pre-suspended data:', error);
    } finally {
      this.loadingService.setLoading(false);
    }
  }

  getWhatsappNumber(): string {
    return this.whatsappNumbers[this.currentLang] || '+15612034066'; // Default number if there is no number for the current language
  }
}
